<template>
<div id="create-partner-app">
  <h2>Create Partner App</h2>

  <partner-app-form
    :partnerId="partnerId"
  ></partner-app-form>
</div>
</template>

<script>
import PartnerAppForm from '@/components/PartnerAppForm'

export default {
  components: {
    'partner-app-form': PartnerAppForm
  },

  props: ['partnerId'],

  methods: {
    processErrors (resp) {
      this.$parent.processErrors(resp)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PartnerAppCreate.vue